import { render, staticRenderFns } from "./SeriesDescTile.vue?vue&type=template&id=01906aed&scoped=true&"
import script from "./SeriesDescTile.vue?vue&type=script&lang=js&"
export * from "./SeriesDescTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01906aed",
  null
  
)

component.options.__file = "SeriesDescTile.vue"
export default component.exports